import { Ref, ref } from 'vue';
import { defineStore } from 'pinia';

export type Schedule = {
    [date: string]: Event[];
};

type Event = {
    start: string;
    end: string;
    staff: string[];
};

export const useAvailabilityStore = defineStore('bookingTimes', () => {
    const state = ref<Schedule>({});
    const setAvailability = (availability: any): void => {
        state.value = availability;
    };

    const resetAvailability = (): void => {
        state.value = {};
    };
    const getAllData = (): Ref<Schedule> => state;

    const isEmpty = (): boolean => {
        return Object.keys(state.value).length === 0;
    };

    return {
        state,
        setAvailability,
        resetAvailability,
        getAllData,
        isEmpty,
    };
});
